module.exports = __webpack_public_path__ + "img/orange-and-red-lily.605ce0e4.webp";